import React from 'react';
import '../template-file-css/document-file-template.css';


export const RPBS_ArPrivacyPracticesNotice = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RPBS_ArPrivacyPracticesNotice' className='file-pdf-document'>
            <div className='file-template'>
            <h3>Acknowledgement of Receipt of the Privacy Practices Notice</h3>
<p className='w-750'>RPBHS is required by law to maintain the privacy of PHI of you or your child/ward. This notice describes how mental helath and medical information about you may be used and disclosed and how you can access this information. RPBHS can use PHI for you or your child's/ward's treatment, payment, healthcare operations and if required via subpoena. No other disclosures of you or your child's ward's PHI will be made without your written authorization to do so. You or your child/ward have other rights, which include the right to request confidential communications, to reques restictions on use and disclosure, to revoke a consent for authorization, to review and copy you or your child's/ward's medical record, to amend the record, to an accounting, and to requests a paper copy of the notice of privacy practices.</p>
<p className='w-750'>It is the intent of RPBHS to make you aware of the possible uses and disclosures of you or your child's/ward's PHI and privacy rights. The delivery of you or your child's/ward's healthcare service will in no way be conditined upon your signed acknowledgement. If you decline to provide a signed acknowledgement, we will continue to provide you or your child/ward treatment and to use and disclose you or your child's/ward's PHI for treatment, payment, and healthcare operations when necessary.</p>
<p className='w-750'>By signing below, I acknowledge receipt and understanding of this notice of privacy practices.</p>


<table>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                        
                       
                    </tr>
                    <tr>
                        <td className='small w-750'> Signature  </td>
                       
                    </tr>
                </table>

                
            </div>
        </form>

    )
}











